export default __webpack_public_path__ + "static/media/104.c8d5f1bd.png";